import { render, staticRenderFns } from "./addTaskStep2.vue?vue&type=template&id=4bdad7d0&"
import script from "./addTaskStep2.vue?vue&type=script&lang=js&"
export * from "./addTaskStep2.vue?vue&type=script&lang=js&"
import style0 from "./addTaskStep2.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports